import repo from "@/modules/auth_repo";
import router from "@/router";

const state = {
  alert: null,
  loading: false,
  user: null
};

const getters = {
  isAuthenticated(state) {
    return state.user !== null && state.user !== undefined;
  }
};

const mutations = {
  setAlert(state, payload) {
    state.alert = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setUser(state, payload) {
    state.user = payload ? { email: payload.email, uid: payload.uid } : null;
  }
};

const actions = {
  async autoSignIn({ commit, dispatch, rootGetters }, { uid, email }) {
    commit("setUser", { email, uid });
    await dispatch("user/fetchUserData", { uid }, { root: true });
    const customerId = rootGetters["user/getActiveCustomerId"];
    await dispatch("customer/switchCustomer", { customerId }, { root: true });
  },
  async changePassword({ commit }, { newPassword }) {
    commit("setLoading", true);
    try {
      await repo.changePassword(newPassword);
      commit("setAlert", {
        message: "Your password was updated successfully!",
        type: "success"
      });
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setLoading", false);
  },
  async changeEmail({ commit, dispatch }, { newEmail }) {
    commit("setLoading", true);
    try {
      await repo.changeEmail(newEmail);
      commit("setAlert", {
        message: "Your email was updated successfully!",
        type: "success"
      });
      await dispatch("user/changeEmail", { email: newEmail }, { root: true });
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setLoading", false);
  },
  async confirmPasswordReset({ commit }, { code, newPassword }) {
    commit("setLoading", true);
    try {
      await repo.confirmPasswordReset(code, newPassword);
      commit("setAlert", {
        message: "Your password was updated successfully!",
        type: "success"
      });
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setLoading", false);
  },
  async resetPassword({ commit }, { email }) {
    commit("setLoading", true);
    try {
      await repo.sendPasswordResetEmail(email);
      commit("setAlert", {
        message:
          "We've just sent you an email with a link to reset your password.",
        type: "info"
      });
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setLoading", false);
  },
  async userSignIn(
    { rootState, commit, dispatch, rootGetters },
    { email, password }
  ) {
    commit("setLoading", true);
    try {
      const user = await repo.signIn(email, password);
      await dispatch("user/fetchUserData", { uid: user.uid }, { root: true });
      if (rootState.user.alert && rootState.user.alert.type === "error") {
        await repo.signOut();
        throw new Error(rootState.user.alert.message);
      }
      const customerId = rootGetters["user/getActiveCustomerId"];
      await dispatch("customer/switchCustomer", { customerId }, { root: true });
      commit("setAlert", null);
      commit("setUser", user);
      router.push("/");
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setLoading", false);
  },
  async userSignOut({ commit }) {
    await repo.signOut();
    router.push("/login", () => {
      commit("setUser", null);
      commit("user/clearUserData", null, { root: true });
      commit("customer/clearCustomerData", null, { root: true });
    });
  }
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};
